import { render, staticRenderFns } from "./myGoalsTotalSavings.vue?vue&type=template&id=141f97a4&scoped=true"
import script from "./myGoalsTotalSavings.js?vue&type=script&lang=js&external"
export * from "./myGoalsTotalSavings.js?vue&type=script&lang=js&external"
import style0 from "./myGoalsTotalSavings.vue?vue&type=style&index=0&id=141f97a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f97a4",
  null
  
)

export default component.exports